<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Perda espigas inteiras (%)
                                </mat-label>
                                <input matInput id="txtPerda_espigas_inteiras" #txtPerda_espigas_inteiras maxlength="10"
                                    formControlName="Perda_espigas_inteiras" readonly class="InputBlockColor"
                                    currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPerda_espigas_inteiras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Perda_espigas_inteiras)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Perda grãos debulhados na despalha (%)
                                </mat-label>
                                <input matInput id="txtPerda_graos_debulhados_despalha"
                                    #txtPerda_graos_debulhados_despalha maxlength="10"
                                    formControlName="Perda_graos_debulhados_despalha" readonly class="InputBlockColor"
                                    currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPerda_graos_debulhados_despalha.value.length}} /
                                    10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Perda_graos_debulhados_despalha)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}"
                                [class.mat-form-field-invalid]="warningValidatorPerdaTotal()">
                                <mat-label class="InputLabelColor"> Perda total na despalha (%)
                                </mat-label>
                                <input matInput id="txtPerda_total_despalha" #txtPerda_total_despalha maxlength="10"
                                    formControlName="Perda_total_despalha" readonly="false" class="InputBlockColor"
                                    currencyMask>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPerda_total_despalha.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Perda_total_despalha)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Limpeza Manual
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <mat-select formControlName="limpeza_manual" disableOptionCentering>
                                    <mat-option *ngFor="let item of listLimpezaManual" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inicio Limpeza Manual Data</mat-label>
                                <input matInput id="txtInicioLimpezaManualData" #txtInicioLimpezaManualData
                                    maxlength="10" [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="inicio_limpeza_manual_data" (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtInicioLimpezaManualData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_limpeza_manual_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inicio Limpeza Manual Hora</mat-label>
                                <input matInput id="txtInicioLimpezaManualHora" #txtInicioLimpezaManualHora
                                    maxlength="5" [dropSpecialCharacters]="false"
                                    formControlName="inicio_limpeza_manual_hora" mask="Hh:m0"
                                    (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtInicioLimpezaManualHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_limpeza_manual_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fim Limpeza Manual Data</mat-label>
                                <input matInput id="txFimLimpezaManualData" #txFimLimpezaManualData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="fim_limpeza_manual_data" (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txFimLimpezaManualData.value.length}} / 10</mat-hint>
                                <mat-error>Data Fim não pode ser anterior a Data Inicio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Fim Limpeza Manual Hora</mat-label>
                                <input matInput id="txtFimLimpezaManualHora" #txtFimLimpezaManualHora maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="fim_limpeza_manual_hora"
                                    mask="Hh:m0" (blur)="validDates($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtFimLimpezaManualHora.value.length}} / 5</mat-hint>
                                <mat-error>Data Fim não pode ser anterior a Data Inicio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>